(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/enetpulse-eventstats-widget-definition.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/enetpulse-eventstats-widget-definition.js');
"use strict";


const KambiWidgetDefinition = svs.oddset_kambi.components.kambiWidgetUtils.definitions.KambiWidgetDefinition;
const {
  WIDGET_ID,
  WIDGET_TAG
} = svs.oddset_kambi.components.kambiWidgetUtils.constants;
const {
  buildFilter
} = svs.oddset_kambi.components.kambiWidgetUtils;
const ENETPULSE_FILTER = {
  fotboll: [],
  ishockey: {
    nhl: [],
    ahl: [],
    vm: [],
    'olympiska-vinterspelen': [],
    finland: ['liiga'],
    schweiz: ['nla'],
    tyskland: ['del-bundesliga']
  }
};
class EnetpulseEventStatsWidgetDefinition extends KambiWidgetDefinition {
  constructor() {
    super(WIDGET_ID.enetpulseEventStats, WIDGET_TAG.enetpulseEventStats, {
      eventColumn2Placeholder2: [{
        widgetId: WIDGET_ID.enetpulseEventStats,
        order: 3,
        filter: "^(?!.*/esports).*".concat(buildFilter(ENETPULSE_FILTER))
      }]
    }, {
      live: true
    });
  }
}
setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.definitions.EnetpulseEventStatsWidgetDefinition', EnetpulseEventStatsWidgetDefinition);

 })(window);